'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _withStyles = require('../with-styles');

var _withStyles2 = _interopRequireDefault(_withStyles);

var _styles = require('./styles');

var _styles2 = _interopRequireDefault(_styles);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var LeaderboardItem = function LeaderboardItem(_ref) {
  var amount = _ref.amount,
      classNames = _ref.classNames,
      href = _ref.href,
      image = _ref.image,
      LinkTag = _ref.linkTag,
      linkProps = _ref.linkProps,
      rank = _ref.rank,
      subtitle = _ref.subtitle,
      target = _ref.target,
      title = _ref.title;

  return _react2.default.createElement(
    'li',
    { className: 'c11n-leaderboard-item ' + classNames.root },
    _react2.default.createElement(
      LinkTag,
      _extends({
        href: href,
        target: target,
        rel: target === '_blank' ? 'noopener' : undefined
      }, linkProps),
      _react2.default.createElement(
        'div',
        { className: classNames.link },
        rank && _react2.default.createElement(
          'div',
          { className: classNames.rank },
          rank
        ),
        image && _react2.default.createElement('img', { src: image, alt: title, className: classNames.image }),
        _react2.default.createElement(
          'div',
          { className: classNames.info },
          _react2.default.createElement(
            'div',
            { className: classNames.title },
            title
          ),
          subtitle && _react2.default.createElement(
            'div',
            { className: classNames.subtitle },
            subtitle
          )
        ),
        amount && _react2.default.createElement(
          'div',
          { className: classNames.amount },
          amount
        )
      )
    )
  );
};

LeaderboardItem.propTypes = {
  /**
   * The tag or component to be used as the link. e.g. `a`, React Router `Link`
   */
  linkTag: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.element, _propTypes2.default.func]),

  /**
   * Props to be applied to the linkTag
   */
  linkProps: _propTypes2.default.object,

  /**
   * The url of the leader's page. Passed to linkTag as `href` prop
   */
  href: _propTypes2.default.string,

  /**
   * The target for the link. e.g. `_blank`
   */
  target: _propTypes2.default.string,

  /**
   * The avatar for the leader
   */
  image: _propTypes2.default.string,

  /**
   * The name or title of the leader
   */
  title: _propTypes2.default.string.isRequired,

  /**
   * The charity or subtitle of the leader
   */
  subtitle: _propTypes2.default.string,

  /**
   * The rank of the leader (optional)
   */
  rank: _propTypes2.default.number,

  /**
   * The amount being ranked by
   */
  amount: _propTypes2.default.string,

  /**
   * The custom styles to be applied
   */
  styles: _propTypes2.default.object
};

LeaderboardItem.defaultProps = {
  linkTag: 'a',
  target: '_blank',
  href: '#',
  styles: {}
};

exports.default = (0, _withStyles2.default)(_styles2.default)(LeaderboardItem);


//////////////////
// WEBPACK FOOTER
// ../~/constructicon/leaderboard-item/index.js
// module id = 268
// module chunks = 0